function getFormatedMessages(msg){
  if(msg){
    all_mass =  msg.split("|");
    var err = "<ul>";
    for(i=0;i<all_mass.length;i++){
      if(all_mass[i]) {
        err += "<li>" + all_mass[i] + "</li>";
      }
    }
    err+="</ul>";
    return err;
  }
}
  
function goToByScroll(id){
  $('html,body').animate({
    scrollTop: $("#"+id).offset().top},
                         1000);
}  
/*function checkValidity(email,password){
  var numConsecutiveChars = 3;
  var username = email;
  var password = password;
  
  // first find all combinations that should not be found in password
  var invalidCombinations = [];
  for( var i = 0; i < username.length - numConsecutiveChars; i++ ){
    var curCombination = username[i] + username[i+1];
    invalidCombinations.push( curCombination );
  }//for
  
  // now check all invalidCombinations
  var invalid = false;
  for( var i = 0; i < invalidCombinations.length; i++ ){
    var curCombination = invalidCombinations[i];
    if( password.indexOf( curCombination ) !== -1 ){
      invalid = true;
      break;
    }
  }//for()
  
  if( invalid ){
   return false ;
  }else{
    return true;
  }
}*/

function checkValidity(email,password){
 email=email.replace(/@.*/,""); //
 var password_length = password.length;
 var email_length = email.length;
 email = email.split(/[.\-_]/);
 var flag =0;
 for (var i = 0; i< email.length; i++) {
  if(email[i].length>password_length){
   console.log("email big");
   if (email[i].match(password)) { 
    console.log("Match",email[i],password);
    flag++;
   }
  }else{
   if (password.match(email[i])) { 
    flag++;
   }
  }
 }
 if(flag>0){
  return false ;
 }else{
  return true ;
 }
}


